export default "__VITE_ASSET__c2829858__"